import { useEffect, useState } from "react";
import useConfiguration from "../../hooks/useConfiguration";
import { useDispatch, useSelector } from "react-redux";
import { getTextNotificationData } from "./action";
import Loader from "../common/Loader";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import DateField from "../common/TextField/dateTime";
import AccordianTable from "./AccordianTable";
import {  resetTextNotificationParams, setParams,  updateTextNotificationParams } from "./slice";
import NotifyFilter from "../common/NotifyFilter/NotifyFilter";

const readList = [
  { name: "All", id: null },
  { name: "Read", id: 1 },
  { name: "Unread", id: 0 },
  // { name: "Archived", id: 2 },
];

const TextNotification = () => {
  const { params, data, masterData, totalCount } = useSelector(
    (store) => store.textNotification
  );
  const [showFilter, setShowFilter] = useState(false);
  const dispatch = useDispatch();

  // hooks
  const config = useConfiguration();
  const headerList =      [
    {
      Header: "candidateName",
      accessor: "candidateName",
    },
    {
      Header: "subject",
      accessor: "subject",

    },
    {
      Header: "message",
      accessor: "message",

    },
    {
      Header: "messageDateTime",
      accessor: "messageDateTime",

    },
    {
      Header: "sms",
      accessor: "sms",
    },
    {
      Header: "read/unread",
      accessor: "readStatus",
    },
    {
      Header: "archieved/unread",
      accessor: "archievedStatus",
    },
    {
      Header: "delete",
      accessor: "delete",

    },
  ]
  // data
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(
        getTextNotificationData({
          url: `${config.baseUrl}/Employers/get-inbox-messages`,
          params,
        })
      );
    }
  }, [config.baseUrl]);

  // handlers
  const handlePageChange = (pageNumber) => {
    const newparams = {
      ...params,
      page: pageNumber,
    };

    dispatch(
        getTextNotificationData({
        url: `${config.baseUrl}/Employers/get-inbox-messages`,
        params: newparams,
      })
    ).then(() => dispatch(setParams(newparams)));
  };
  const handlePageSize = (pageSize) => {
    const newparams = {
      ...params,
      pageSize: pageSize,
      page: 1,
    };
    dispatch(
        getTextNotificationData({
        url: `${config.baseUrl}/Employers/get-inbox-messages`,
        params: newparams,
      })
    ).then(() => dispatch(setParams(newparams)));
  };

  useEffect(() => {
    dispatch(resetTextNotificationParams());
  }, []);

  const updateTextNotifyParams = (target) => {
    const { name, value } = target;
    dispatch(updateTextNotificationParams({ name, value }));
  };
  const updateReadStatusTextNotifyParams = (target) => {
    const { name, value } = target;
    dispatch(updateTextNotificationParams({ name, value }));
  };

  const filterData = () => {
    if (
      params?.startDate ||
      params?.endDate || params.message
    ) {
      dispatch(
        getTextNotificationData({
        url: `${config.baseUrl}/Employers/get-inbox-messages`,
        params,
      }))
    }
  };
  const clearFilter = () => {
    if (
      params?.startDate ||
      params?.endDate ||
      params?.message
    ) {
      const newparams = {
        ...params,
        message: "",
        startDate: null,
        endDate: null,
      };
      dispatch(
        getTextNotificationData({
        url: `${config.baseUrl}/Employers/get-inbox-messages`,
        params:newparams,
      }))
      .then(() => dispatch(setParams(newparams)));
    }
  };
  const notifyParamChanges = (updatedParams) => {
    const newparams = {
      ...params,
      message: `${updatedParams?.messageStatus?.id ?? ""}`,
      startDate: updatedParams?.fromDateRange,
      endDate: updatedParams?.toDateRange,
      searchText: updatedParams?.searchText,
      isArchived: updatedParams?.isArchived
    };
    dispatch(
      getTextNotificationData({
      url: `${config.baseUrl}/Employers/get-inbox-messages`,
      params:newparams,
    }))
    .then(() => dispatch(setParams(newparams)));
  };
  return (
    <div className="page main-margin">
      <Loader />
      <Header />
      <Sidebar />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Text Messages</h1>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Search Text Messages</h3>
                    </div>
                    {/* <div className="card-body">
                      <div className="row">
                        <div className="input-group mb-3 col-lg-6 col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                          <button className="btn btn-primary" type="submit">
                            <i className="fe fe-search"></i>
                          </button>
                        </div>
                        <div className="col-lg-6 col-md-4">
                          <button
                            className="btn btn-primary"
                            onClick={() => setShowFilter(!showFilter)}
                          >
                            <i className="bi bi-filter fa-lg"></i>Filter
                          </button>
                        </div>
                      </div>
                      <br />
                      {showFilter && (
                        <>
                          <div className="row">
                            <DateField
                              name={"startDate"}
                              divClass="col-lg-3 col-md-3"
                              label={"Received Date Range From"}
                              id={"startDate"}
                              value={
                                params?.startDate
                                  ? params?.startDate
                                  : ""
                              }
                              updateValue={updateTextNotifyParams}
                              includeTime={false}
                            />
                            <DateField
                              name={"endDate"}
                              divClass="col-lg-3 col-md-3"
                              label={"Received Date Range To"}
                              id={"endDate"}
                              value={
                                params?.endDate ? params?.endDate : ""
                              }
                              updateValue={updateTextNotifyParams}
                              includeTime={false}
                            />
                            <div className="col-lg-3 col-md-3">
                              <div className="form-group">
                                <label htmlFor={"message"}>
                                  Read/Unread
                                </label>
                                <select
                                  className="form-select"
                                  data-placeholder="Read/Unread"
                                  value={ params?.message ?  params?.message :""}
                                  id={"message"}
                                  name={"message"}
                                  onChange={(e) =>
                                    updateReadStatusTextNotifyParams(e.target)
                                  }
                                >
                                  <option value={""}>All</option>
                                  {masterData?.readList?.map((option) => (
                                    <option value={option?.value}>
                                      {option?.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                         
                          </div>
                          <div className="row pull-right">
                            <div className="d-flex">
                              <button
                                className="btn btn-outline-primary me-3"
                                onClick={filterData}
                              >
                                Apply
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={clearFilter}
                              >
                                Clear Filter
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div> */}
                    <div className="card-body">
                      <NotifyFilter 
                      notifyParamChanges={notifyParamChanges} 
                      readList={readList}
                      />
                    </div>
                  </div>
                  <AccordianTable
                    textNotificationData={data}
                    handlePageChange={handlePageChange}
                    currentPage={params.page}
                    pageSize={params.pageSize}
                    totalCount={totalCount}
                    handlePageSize={handlePageSize}
                    headerList = {headerList}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextNotification;
